import colors from 'styles/colors'

const styles = {
  disclaimer: {
    border: `1px solid ${colors.lightGray}`,
    margin: '30px 0 15px 0',
    fontSize: 14,
    padding: '5px'
  },
  divider: {
    marginTop: 15,
    borderTop: `1px solid ${colors.lightGray}`
  },
  footerBottom: {
    display: 'flex',
    flexWrap: 'nowrap',
    padding: '0 5px',
    justifyContent: 'space-between',
    wordWrap: 'normal',
    fontStyle: 'italic'
  },
  pageNumber: {
    minWidth: 100,
    textAlign: 'right'
  }
}

export default styles

